export enum TicketPriority {
  Unknown,
  Low = 1,
  Medium = 2,
  High = 3,
  Critical = 4,
}
